export const SettingsErrors: Record<string, string> = {
  //DADOS
  'It is necessary to inform the CNPJ of the company':
    'É necessário informar o CNPJ da empresa',
  'It is necessary to inform the fantasy name of the company':
    'É necessário informar o nome fantasia da empresa',
  'It is necessary to inform the corporate name of the company':
    'É necessário informar a razão social da empresa',
  'It is necessary to inform the state registration of the company':
    'É necessário informar o registro estadual da empresa',
  'It is necessary to inform the municipal registration of the company':
    'É necessário informar o registro municipal da empresa',
  'It is necessary to inform the tax regime of the company':
    'É necessário informar o regime tributário da empresa',
  'At least one type of note must be enabled.':
    'Pelo menos um tipo de nota deve estar ativado.',
  //ENDEREÇO
  'It is necessary to inform the address of the company':
    'É necessário informar o endereço da empresa',
  'It is necessary to inform the zipcode of the company':
    'É necessário informar o CEP da empresa',
  'It is necessary to inform the city of the company':
    'É necessário informar a cidade da empresa',
  'It is necessary to inform the district of the company':
    'É necessário informar o distrito da empresa',
  'It is necessary to inform the street of the company':
    'É necessário informar a rua da empresa',
  'It is necessary to inform the number of the company':
    'É necessário informar o número da empresa',
  //CONTATOS
  'It is necessary to inform the contact of the company':
    'É necessário informar o contato da empresa',
  'It is necessary to inform the email of the company':
    'É necessário informar o e-mail da empresa',
  'It is necessary to inform the phone of the company':
    'É necessário informar o telefone da empresa',
  //OUTROS
  'No value present': 'Nenhum valor presente',
};
